import { type AnswerData } from "@repo/api";
import {
  type ReactNode,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface Props {
  children: ReactNode;
}

interface AnswersContextType {
  answers: AnswerData[];
  updateAnswers: (answerData: AnswerData[]) => void;
  b2bAnswers: AnswerData[];
  updateB2bAnswers: (answerData: AnswerData[]) => void;
}
const AnswersContext = createContext<AnswersContextType>({} as any);

export const AnswersProvider = ({ children }: Props) => {
  const [answers, setAnswers] = useState<AnswerData[]>([]);
  const [b2bAnswers, setB2bAnswers] = useState<AnswerData[]>([]);

  const updateAnswers = useCallback((answerData: AnswerData[]) => {
    setAnswers(answerData);
  }, []);

  const updateB2bAnswers = useCallback((answerData: AnswerData[]) => {
    setB2bAnswers(answerData);
  }, []);

  const value = useMemo(
    () => ({ answers, updateAnswers, b2bAnswers, updateB2bAnswers }),
    [answers, updateAnswers, b2bAnswers, updateB2bAnswers]
  );

  return (
    <AnswersContext.Provider value={value}>{children}</AnswersContext.Provider>
  );
};

export const useAnswers = () => useContext(AnswersContext);
